import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Provider } from 'react-redux';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { store } from './store';
import AppShell from './components/AppShell/AppShell';
import RequireAuth from './components/RequireAuth';
import LoginPage from './pages/login/LoginPage';
import HubPage from './pages/hub/HubPage';
import ThankYouPage from './pages/thankYou/ThankYouPage';
import MatchsticksPage from './pages/games/matchsticks/MatchsticksPage';
import CandyCrushPage from './pages/games/candyCrush/CandyCrushPage';
import RangoliPage from './pages/games/rangoli/RangoliPage';

function App() {
  return (
    <Provider store={store}>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/login" element={<LoginPage />} />

        <Route
          element={
            <RequireAuth>
              <AppShell />
            </RequireAuth>
          }
        >
          <Route path="/welcome" element={<Navigate to="/hub" replace />} />
          <Route path="/hub" element={<HubPage />} />
          <Route path="/games/candy-crush" element={<CandyCrushPage />} />
          <Route path="/games/matchsticks" element={<MatchsticksPage />} />
          <Route path="/games/rangoli" element={<RangoliPage />} />
          <Route path="/thank-you" element={<ThankYouPage />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Provider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

reportWebVitals();
